import moment from 'moment';
import t from './types';
import { Object } from 'es6-shim';

const groupByDate = (events, filter = null) => {
  return events.reduce((groupedEvents, event) => {
    const date = moment
      .utc(event.startsAt)
      .local()
      .format('Y-MM-DD');

    if (!filter || date === filter) {
      groupedEvents[date] = groupedEvents[date] || [];
      groupedEvents[date].push(event);
    }

    return groupedEvents;
  }, {});
};

const sortByName = events => {
  return events.sort((a, b) => {
    if (`${a.meetingName} ${a.number}` < `${b.meetingName} ${b.number}`) return -1;
    if (`${a.meetingName} ${a.number}` > `${b.meetingName} ${b.number}`) return 1;
    return 0;
  });
};

const sortByTime = events => {
  return events.sort((a, b) => {
    if (a.startsAt < b.startsAt) return -1;
    if (a.startsAt > b.startsAt) return 1;
    return 0;
  });
};

export default {
  categories: state => {
    return state.categories;
  },

  groups: state => {
    return state.groups;
  },

  events: state => {
    switch (state.currentSort) {
      case t.SORT_NAME:
        return groupByDate(sortByName(state.events), state.dateFilter);

      case t.SORT_TIME:
        return groupByDate(sortByTime(state.events), state.dateFilter);

      default:
        return groupByDate(state.events, state.dateFilter);
    }
  },

  eventFilter: state => {
    return Number(state.eventFilter);
  },

  eventRunners: state => {
    return Number(state.eventRunners);
  },

  selections: state => {
    return state.selections;
  },

  metrics: state => {
    return state.metrics;
  },

  presets: state => {
    return state.presets;
  },

  currentPreset: state => {
    return state.currentPreset;
  },

  sort: state => {
    return state.sort;
  },

  currentSort: state => {
    return state.currentSort;
  },

  count: state => {
    return state.count;
  },

  dayRange: state => {
    return state.dayRange;
  },

  fields: (state, getters) => {
    return getters['FormFinder/orderedFields'].map(([id, field]) => ({
      id,
      name: field.name,
      category: field.category,
      group: field.group,
      label: field.label,
      metric: field.metric,
      metrics: field.metrics,
      range: field.range,
    }));
  },

  fieldDescriptions: (state, getters) => {
    return getters['FormFinder/orderedFields'].map(([, { label, description }]) => ({ label, description }));
  },

  orderedFields: state => {
    return Object.entries(state.fields).sort((a, b) => a.order - b.order);
  },

  runnerCount: state => {
    let count = 0;

    state.events.forEach(event => (count += event.selections.length));

    return count;
  },

  query: state => {
    return state.query;
  },

  dateFilter: state => {
    return state.dateFilter;
  },

  dateSortOptions: state => {
    const options = [];

    for (const date of Object.keys(groupByDate(state.events))) {
      options.push({
        label: moment(date).calendar(null, {
          sameDay: '[Today]',
          nextDay: '[Tomorrow]',
          nextWeek: 'dddd',
          sameElse: 'dddd',
        }),
        value: date,
      });
    }

    return options;
  },

  featuredPresets: state => {
    return state.featuredPresets.map(featuredPresetName => {
      let label;

      state.presets.forEach(preset => {
        if (preset.name === featuredPresetName) {
          label = preset.displayName;
        }
      });

      return {
        label,
        value: featuredPresetName,
      };
    });
  },

  info: state => {
    return state.info && state.info.faq && state.info.faq.length
      ? {
          heading: state.info.faq[0].question,
          description: state.info.faq[0].answer,
        }
      : {};
  },
};
